class e {
  constructor(s, t) {
    this.reason = s, this.explanation = t;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
export {
  e as default
};
//# sourceMappingURL=contact-channels136.js.map
